// ==============================|| ENVIRONMENT CONFIGURATION ||============================== //

/**
 * Environment configuration for Thiscreet Dashboard
 * All environment variables should be prefixed with VITE_ to be accessible in the browser
 */

// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "http://localhost:3001/api/v1",
  TIMEOUT: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
};

// Application Configuration
export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || "Thiscreet Dashboard",
  VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || "Advanced user metrics and analytics dashboard",
};

// Development Configuration
export const DEV_CONFIG = {
  IS_DEV_MODE: import.meta.env.VITE_DEV_MODE === 'true' || import.meta.env.DEV,
  IS_DEBUG: import.meta.env.VITE_DEBUG === 'true',
  IS_PRODUCTION: import.meta.env.PROD,
};

// Firebase Configuration (for production)
export const FIREBASE_CONFIG = {
  PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

// Utility functions
export const getApiUrl = (endpoint = '') => {
  const baseUrl = API_CONFIG.BASE_URL.endsWith('/') 
    ? API_CONFIG.BASE_URL 
    : `${API_CONFIG.BASE_URL}/`;
  
  return endpoint.startsWith('/') 
    ? `${baseUrl}${endpoint.slice(1)}` 
    : `${baseUrl}${endpoint}`;
};

export const isEnvironmentValid = () => {
  const requiredVars = [
    'VITE_API_BASE_URL'
  ];

  const missingVars = requiredVars.filter(varName => {
    const value = import.meta.env[varName];
    return !value || value.trim() === '';
  });

  if (missingVars.length > 0) {
    console.warn('Missing required environment variables:', missingVars);
    return false;
  }

  return true;
};

// Log configuration in development
if (DEV_CONFIG.IS_DEV_MODE) {
  console.log('🚀 Thiscreet Dashboard Configuration:', {
    API_BASE_URL: API_CONFIG.BASE_URL,
    APP_NAME: APP_CONFIG.NAME,
    VERSION: APP_CONFIG.VERSION,
    DEBUG_MODE: DEV_CONFIG.IS_DEBUG,
    ENVIRONMENT: DEV_CONFIG.IS_PRODUCTION ? 'production' : 'development'
  });

  // Validate environment
  if (!isEnvironmentValid()) {
    console.error('❌ Environment validation failed! Please check your .env file.');
  } else {
    console.log('✅ Environment validation passed!');
  }
}
